/** Absolute URL with the given query; null and undefined values are left out. */
export const buildUrl = (base: string, params: Record<string, unknown>) => {
  const url = new URL(base);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null)
      url.searchParams.append(key, String(value));
  });
  return url.toString();
};
